/* Medicus — "Tell us where it's going"
 * ---------------------------------------------------------------------------
 * Rebuilds the head of YMQ's 542tem7 text field: Pango asks the question, and
 * the answers people actually give are offered as chips.
 *
 * THE ONLY THING THIS EVER WRITES IS THAT FIELD'S OWN INPUT, and only from a
 * chip the customer tapped. No other YMQ value is read for writing, nothing is
 * selected on their behalf, and the field stays a free-text box: type over it,
 * clear it, ignore the chips entirely.
 *
 * If anything here fails, the catch leaves YMQ's own field exactly as it was.
 * --------------------------------------------------------------------------- */
(function () {
  'use strict';

  var FIELD_ID = '542tem7';
  var FIELD_LABEL = /tailor to your industry/i;
  var SEP = ', ';

  function all(sel, root) { return [].slice.call((root || document).querySelectorAll(sel)); }
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  function readConfig() {
    var node = document.querySelector('[data-mc-tellus-config]');
    if (!node) return null;
    try { return JSON.parse(node.textContent); } catch (e) { return null; }
  }

  /* Id first, label second: renaming the option in YMQ must not break this,
     and neither must YMQ renumbering the set. */
  function findBox() {
    var byId = document.querySelector('.ymq-options-box[ymq-option-id="' + FIELD_ID + '"]');
    if (byId) return byId;
    var boxes = all('.ymq-options-box[ymq-option-type="1"]');
    for (var i = 0; i < boxes.length; i++) {
      if (FIELD_LABEL.test(boxes[i].getAttribute('ymq-option-label') || '')) return boxes[i];
    }
    return null;
  }

  /* The value as a list of trimmed parts, so a chip can be added, found and
     removed without disturbing anything the customer typed themselves. */
  function parts(input) {
    return String(input.value || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
  }

  /* YMQ listens for input/change to build the line-item property, so both are
     dispatched — setting .value alone would show the text and cart nothing. */
  function setValue(input, list) {
    input.value = list.join(SEP);
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function build(cfg, box, input) {
    var c = cfg.copy;
    var wrap = el('div', 'mc-tellus');
    wrap.setAttribute('data-mc-tellus', '');

    var head = el('div', 'mc-tellus__head');
    if (cfg.pose) {
      var img = el('img', 'mc-tellus__pango');
      img.src = cfg.pose;
      img.alt = cfg.pose_alt || '';
      img.loading = 'lazy';
      img.width = 88; img.height = 89;
      head.appendChild(img);
    }
    var words = el('div', 'mc-tellus__words');
    words.appendChild(el('h3', 'mc-tellus__title', c.heading));
    words.appendChild(el('p', 'mc-tellus__lede', c.lede));
    head.appendChild(words);
    wrap.appendChild(head);

    var label = el('p', 'mc-tellus__chips-label', c.chips_label);
    wrap.appendChild(label);

    var row = el('div', 'mc-tellus__chips');
    row.setAttribute('role', 'group');
    row.setAttribute('aria-label', c.chips_label);

    var thanks = el('p', 'mc-tellus__thanks', c.thanks);
    thanks.hidden = true;

    function sync() {
      var have = parts(input).map(function (s) { return s.toLowerCase(); });
      all('.mc-tellus__chip', row).forEach(function (b) {
        var on = have.indexOf(b.dataset.value.toLowerCase()) > -1;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      var any = parts(input).length > 0;
      thanks.hidden = !any;
      clear.hidden = !any;
    }

    (cfg.chips || []).forEach(function (text) {
      var b = el('button', 'mc-tellus__chip', text);
      b.type = 'button';
      b.dataset.value = text;
      b.setAttribute('aria-pressed', 'false');
      b.addEventListener('click', function () {
        var list = parts(input);
        var at = -1;
        for (var i = 0; i < list.length; i++) {
          if (list[i].toLowerCase() === text.toLowerCase()) { at = i; break; }
        }
        if (at > -1) list.splice(at, 1); else list.push(text);
        setValue(input, list);
        sync();
      });
      row.appendChild(b);
    });
    wrap.appendChild(row);

    var clear = el('button', 'mc-tellus__clear', c.clear);
    clear.type = 'button';
    clear.hidden = true;
    clear.addEventListener('click', function () { setValue(input, []); sync(); input.focus(); });

    wrap.appendChild(el('p', 'mc-tellus__hint', c.type_hint));

    /* Typing by hand must light the chips too. */
    input.addEventListener('input', sync);
    sync();

    /* The acknowledgement and the reset belong UNDER the box they talk about,
       so they are handed back separately and placed after YMQ's input. */
    var foot = el('div', 'mc-tellus__foot');
    foot.appendChild(thanks);
    foot.appendChild(clear);
    return { head: wrap, foot: foot };
  }

  function mount(cfg) {
    if (document.querySelector('[data-mc-tellus]')) return true;
    var box = findBox();
    if (!box) return false;
    var input = box.querySelector('input.ymq-option-text, input[type="text"]');
    if (!input) return false;

    /* YMQ's own title and help text are replaced, not hidden: the same thing
       is being said, better, and two asks in a row would read as a stutter.
       The input itself is left exactly where YMQ put it. */
    var title = box.querySelector('.ymq-option-title');
    var help = box.querySelector('.ymq-option-help-text');
    var built = build(cfg, box, input);
    if (title) { title.parentNode.insertBefore(built.head, title); title.hidden = true; title.classList.add('mc-tellus-hidden'); }
    else box.insertBefore(built.head, box.firstChild);
    if (help) { help.hidden = true; help.classList.add('mc-tellus-hidden'); }
    var field = input.closest('.ymq-option-text-input-wrapper') || input;
    if (field.parentNode) field.parentNode.insertBefore(built.foot, field.nextSibling);
    else box.appendChild(built.foot);
    box.classList.add('mc-tellus-box');
    return true;
  }

  /* YMQ renders late and re-renders on its own schedule. */

  /* INP fix (7 Sept 2026). YMQ lazy-loads ~930 swatch images over the first
     minute and flips a class on each one as it lands; with five scripts
     watching document.body that was 24s of blocked main thread in the first
     33s of every product page (GSC: product group INP 490ms from 4 Sept).
     Only container-level changes matter to this script; value-level class
     flips, images, the header search box and our own widgets are ignored. */
  var MC_IGNORE_ATTR = '.ymq-option-value,.ymq-option-value-item,.ymq-option-swatches-item,.ymq-option-label,.ymq-option-button-input,img,input,textarea,.search-mega-menu__input';
  var MC_OWN = '[data-mc-fit-card],.mc-fit__check,.mc-emb-cue,.mc-emb-modal,[data-mc-satc],.mc-tellus-box,.mc-terms-box';
  function mcRelevant(records) {
    for (var i = 0; i < records.length; i++) {
      var m = records[i], t = m.target;
      if (t.nodeType !== 1) { t = t.parentElement; if (!t) continue; }
      if (t.closest && t.closest(MC_OWN)) continue;
      if (m.type === 'attributes' && t.matches && t.matches(MC_IGNORE_ATTR)) continue;
      return true;
    }
    return false;
  }

  function start() {
    var cfg = readConfig();
    if (!cfg) return;
    var go = function () { try { return mount(cfg); } catch (e) { return true; } };
    if (go()) return;
    var tries = 0;
    var timer = setInterval(function () {
      tries++;
      if (go() || tries > 60) clearInterval(timer);   /* 60 x 500ms = 30s */
    }, 500);
    try {
      new MutationObserver(function (records) { if (mcRelevant(records)) go(); })
        .observe(document.body, { childList: true, subtree: true });
    } catch (e) { /* the field stands on its own */ }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
